/**
 * Theme toggle
 *
* @version     2.0.0
 * @see         https://hankchizljaw.com/wrote/create-a-user-controlled-dark-or-light-mode/
 */

const STORAGE_KEY = 'user-color-scheme'

/**
 * Apply user preference
 *
* @version     1.0.0
 */
export const applyThemeSetting = passedSetting => {
	const currentSetting = passedSetting || localStorage.getItem(STORAGE_KEY)

	if (currentSetting) {
		document.documentElement.setAttribute(
			'data-user-color-scheme',
			currentSetting
		)
		document.querySelector(`#theme-${currentSetting}`).checked = true
	}
}

/**
 * Toggle theme
 *
* @version     1.0.0
 */
export function toggleThemeSetting(e) {
	const currentSetting = e.target.value
	localStorage.setItem(STORAGE_KEY, currentSetting)
	return currentSetting
}
